export default __webpack_public_path__ + "fonts/eot/iranyekanwebregular.eot";